import {useRef, useState} from 'react'

import Style from './style'

import DefaultButton from 'shared/ui/DefaultButton'
import DefaultModal from 'shared/ui/DefaultModal'
import useUpdateExamPrice from 'entity/exam/useUpdateExamPrice'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'

const QualificationExamModal = ({closeEvent, data, fetchRequest}) => {
	const level_2 = useRef(data?.level_2)
	const level_4 = useRef(data?.level_4)
	const level_6 = useRef(data?.level_6)

	// Format numbers with commas for display
	const formatNumber = (value) => {
		if (!value && value !== 0) return ''
		const num = value.toString().replace(/,/g, '')
		return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
	}

	// Remove commas to get plain number
	const unformatNumber = (value) => {
		if (!value) return ''
		return value.toString().replace(/,/g, '')
	}

	// Store both formatted (for display) and raw (for API) values
	const [formattedPrice2, setFormattedPrice2] = useState(
		formatNumber(data?.price_level_2)
	)
	const [formattedPrice4, setFormattedPrice4] = useState(
		formatNumber(data?.price_level_4)
	)
	const [formattedPrice6, setFormattedPrice6] = useState(
		formatNumber(data?.price_level_6)
	)

	const [rawPrice2, setRawPrice2] = useState(data?.price_level_2 ?? '')
	const [rawPrice4, setRawPrice4] = useState(data?.price_level_4 ?? '')
	const [rawPrice6, setRawPrice6] = useState(data?.price_level_6 ?? '')

	const handlePriceChange = (e, setFormatted, setRaw) => {
		const value = e.target.value
		const unformatted = unformatNumber(value)

		// Only allow numbers
		if (unformatted === '' || /^\d+$/.test(unformatted)) {
			setRaw(unformatted)
			setFormatted(formatNumber(unformatted))
		}
	}

	const [request] = useUpdateExamPrice(fetchRequest)
	const [, setAlert] = useAlertModalAtom()

	const handleApply = () => {
		if (
			rawPrice2 === 0 ||
			rawPrice2 === '' ||
			rawPrice4 === 0 ||
			rawPrice4 === '' ||
			rawPrice6 === 0 ||
			rawPrice6 === ''
		) {
			setAlert('가격을 입력해주세요.')
			return
		}

		request(data?.idx, {
			price_level_1: Number(rawPrice2),
			price_level_2: Number(rawPrice4),
			price_level_3: Number(rawPrice6),
			level_1: level_2.current.value,
			level_2: level_4.current.value,
			level_3: level_6.current.value,
		})
	}

	return (
		<DefaultModal title='자격 시험' closeEvent={closeEvent}>
			<Style.ContentDiv>
				<Style.FormDiv>
					<Style.Row>
						{/* <Style.GradeBox>{data?.level_2}</Style.GradeBox> */}
						<Style.PriceInput
							ref={level_2}
							placeholder='등급'
							defaultValue={data?.level_2}
						/>
						<Style.PriceInput
							placeholder='가격'
							value={formattedPrice2}
							onChange={(e) =>
								handlePriceChange(e, setFormattedPrice2, setRawPrice2)
							}
						/>
					</Style.Row>
					<Style.Row>
						{/* <Style.GradeBox>{data?.level_4}</Style.GradeBox> */}
						<Style.PriceInput
							ref={level_4}
							placeholder='등급'
							defaultValue={data?.level_4}
						/>
						<Style.PriceInput
							placeholder='가격'
							value={formattedPrice4}
							onChange={(e) =>
								handlePriceChange(e, setFormattedPrice4, setRawPrice4)
							}
						/>
					</Style.Row>
					<Style.Row>
						{/* <Style.GradeBox>{data?.level_6}</Style.GradeBox> */}
						<Style.PriceInput
							ref={level_6}
							placeholder='등급'
							defaultValue={data?.level_6}
						/>
						<Style.PriceInput
							placeholder='가격'
							value={formattedPrice6}
							onChange={(e) =>
								handlePriceChange(e, setFormattedPrice6, setRawPrice6)
							}
						/>
					</Style.Row>
				</Style.FormDiv>
				<Style.BtnDiv>
					<DefaultButton clickEvent={handleApply}>적용</DefaultButton>
				</Style.BtnDiv>
			</Style.ContentDiv>
		</DefaultModal>
	)
}

export default QualificationExamModal
